/**
 * Format price with correct precision
 */
export function formatPrice(price: number, metadata: any): string {
  if (price === null || price === undefined || isNaN(Number(price))) return "0";
  const numPrice = Number(price);
  if (isNaN(numPrice)) return "0";
  const precision = metadata?.precision?.price || 2;
  return numPrice.toFixed(precision);
}

/**
 * Format volume for display (K, M, B)
 */
export function formatVolume(volume: number): string {
  if (volume === null || volume === undefined || isNaN(Number(volume))) return "0";
  const numVolume = Number(volume);
  if (isNaN(numVolume) || numVolume === 0) return "0";
  if (numVolume >= 1_000_000_000) {
    return `${(numVolume / 1_000_000_000).toFixed(1)}B`;
  } else if (numVolume >= 1_000_000) {
    return `${(numVolume / 1_000_000).toFixed(1)}M`;
  } else if (numVolume >= 1_000) {
    return `${(numVolume / 1_000).toFixed(1)}K`;
  }
  return `${numVolume.toFixed(0)}`;
}

/**
 * Parse volume string back to number for sorting
 */
export function parseVolume(volumeStr: string): number {
  if (!volumeStr) return 0;

  const multiplier = volumeStr.endsWith("B")
    ? 1_000_000_000
    : volumeStr.endsWith("M")
      ? 1_000_000
      : volumeStr.endsWith("K")
        ? 1_000
        : 1;

  const numericPart = Number.parseFloat(volumeStr.replace(/[KMB]/g, ""));
  return isNaN(numericPart) ? 0 : numericPart * multiplier;
}
